import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    getPAFAA060,
    getPAFAA060Snapshot,
    getPAJAC020CodeListPublic,
    getPAJAC020TaskManager,
    postPAIAE010Choice,
    postPAIAE010DelChoice,
} from '../../../services/Api';
import Nav from '../../../shared/components/Nav';
import PopupSendMail from '../../../shared/components/PopupSendMail';
import { MENU_RESUME } from '../../../shared/constants/app';
import {
    decodeToken,
    formatDate,
    getImageSrc,
    handlePrint,
    parseResumeActiveInfo,
    parseResumeCareerInfo,
    parseResumeLicenseInfo,
    parseResumeSchoolInfo,
} from '../../../utils';

import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ResumePage from '../../../shared/components/ResumePage';
import Ticket from '../../../shared/components/popup/Ticket';
import TicketPurchase from '../../../shared/components/popup/TicketPurchase';
const PAFAA060 = () => {
    const { id } = useParams({});
    const [data, setData] = useState({});
    const printRef = useRef();
    const login = useSelector(({ auth }) => auth.login);
    const decode = decodeToken(login.token);
    const loggedIn = login.loggedIn;
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname.split('-')[0];
    const [searchParams] = useSearchParams();
    const from = searchParams.get('from') || '';
    const isSnapshot = searchParams.get('snap') === 'Y';

    // const handleEmail = (email, isShow) =>
    //     email && isShow === 'Y' ? email : email && email.slice(0, 2) + '***' + email.slice(email.indexOf('@'));
    const [resumeCareerInfo, setResumeCareerInfo] = useState([]);
    const [resumeLicenseInfo, setResumeLicenseInfo] = useState([]);
    const [resumeSchoolInfo, setResumeSchoolInfo] = useState([]);
    const [resumeActiveInfo, setResumeActiveInfo] = useState([]);
    const [isPopupSendMailOpen, setIsPopupSendMailOpen] = useState(false);
    const [isTicketPopupOpen, setIsTicketPopupOpen] = useState(false);
    const [isTicketPurchasePopupOpen, setIsTicketPurchasePopupOpen] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const listContact = [
        { key: 'tel', value: '일반전화' },
        { key: 'mob', value: '휴대폰' },
        { key: 'eml', value: '이메일' },
        { key: 'pps', value: '덴탈잡 쪽지' },
    ];
    const codeLists = {
        A11: [],
        A14: [],
        A27: [],
    };
    const [receiver, setReceiver] = useState({ id: '', name: '' });
    const getContactMethod = (key) => {
        if (!key || typeof key !== 'string') {
            return '';
        }
        const list = key?.split(',');
        const contacts = list.map((k) => {
            const contact = listContact.find((item) => item?.key === k);
            return contact ? contact.value : '';
        });
        return contacts.filter(Boolean).join(', ');
    };

    const closePopup = () => {
        setIsPopupSendMailOpen(false);
    };

    const handleUseTicket = () => {
        if (!data?.wallets || data.wallets.length === 0) {
            if (window.confirm('보유하신 열람권이 없습니다. 열람권을 구매하시겠습니까?')) {
                setIsTicketPurchasePopupOpen(true);
            }
            return;
        }
        setIsTicketPopupOpen(true);
    };

    const getListData = async () => {
        getPAJAC020TaskManager().then((res) => (codeLists.A11 = res.data));
        getPAJAC020CodeListPublic('A14,A27')
            .then(({ data }) => {
                codeLists.A14 = data.A14;
                codeLists.A27 = data.A27;
            })
            .catch((error) => console.log(error));
        await (isSnapshot ? getPAFAA060Snapshot(id) : getPAFAA060(id))
            .then(({ data }) => {
                setData({
                    ...data,
                    resumeClass: getCodeName(data.resumeClass, 'A11'),
                    resumeLicense: getCodeName(data.resumeLicense, 'A14'),
                    resumePosition: getCodeName(data.resumePosition, 'A27'),
                });

                if (data?.resumeCareerInfo && data?.resumeCareerInfo !== '') {
                    setResumeCareerInfo(parseResumeCareerInfo(data?.resumeCareerInfo));
                }
                if (data?.resumeLicenseInfo && data?.resumeLicenseInfo !== '') {
                    setResumeLicenseInfo(parseResumeLicenseInfo(data?.resumeLicenseInfo));
                }
                if (data?.resumeSchoolInfo && data?.resumeSchoolInfo !== '') {
                    setResumeSchoolInfo(parseResumeSchoolInfo(data?.resumeSchoolInfo));
                }
                if (data?.resumeActiveInfo && data?.resumeActiveInfo !== '') {
                    setResumeActiveInfo(parseResumeActiveInfo(data?.resumeActiveInfo));
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 400) {
                    alert('열람권한 없습니다.');
                    navigate('/pafaa010');
                } else {
                    console.log(error);
                }
            })
            .finally(() => setIsDataLoaded(true));
    };

    const removeStar = () => {
        postPAIAE010DelChoice(data?.choiceSeq)
            .then(() => {
                getListData();
            })
            .catch((error) => console.log(error));
    };

    const activeStar = () => {
        postPAIAE010Choice({ tblName: 'Resume', refSeq: id, memberID: decode?.memberID })
            .then(() => {
                getListData();
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        if (window.location.pathname !== '/login' && window.location.pathname !== '/' && id && !loggedIn) {
            if (window.confirm(`회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`)) {
                navigate('/login', { state: { id, path } });
            } else {
                alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                navigate('/');
            }
        }

        // eslint-disable-next-line
    }, [id, loggedIn]);

    useEffect(() => {
        if (id) {
            getListData();
        }
        // eslint-disable-next-line
    }, [id, isSnapshot]);

    // Hàm getCodeName
    const getCodeName = (codes, key) => {
        const list = codeLists[key]; // Lấy danh sách tương ứng với key
        const transformed = (codes || '')?.replace(/_/g, ', ')?.split(',');
        // Nếu không tìm thấy danh sách cho key, trả về mảng null

        if (!list) {
            return Array.isArray(transformed) ? transformed?.map(() => null) : [null];
        }
        // Đảm bảo codes là mảng, nếu không thì chuyển thành mảng
        const codeArray = Array.isArray(transformed) ? transformed : [transformed];

        // Loại bỏ khoảng trắng thừa ở đầu và cuối của từng mã
        const trimmedCodes = codeArray?.map((code) => code?.trim());
        const findCode = trimmedCodes.map((codeOrName) => {
            // Tìm theo code
            let found = list.find((item) => item.code === codeOrName);
            if (found) return found.code;
            // Tìm theo codeName
            found = list.find((item) => item.codeName === codeOrName);
            if (found) return found.code;
            // Không tìm thấy
            return '';
        });

        // Tìm codeName tương ứng cho từng mã đã được trim
        return findCode
            ?.sort((a, b) => Number(a) - Number(b))
            ?.map((code) => {
                const item = list?.find((item) => item?.code === code);
                return item
                    ? `${item?.codeName}${code === findCode[findCode.length - 1] ? '' : ','} `
                    : `${code}${code === findCode[findCode.length - 1] ? '' : ', '}`;
            });
    };
    return (
        <>
            <div id="content">
                <div className="rsm">
                    <div className="container">
                        {location.pathname.startsWith('/pafaa060') && <Nav menu={MENU_RESUME} />}
                        {/* <div className="rsm-mng__btbx mb10 mt10">
                            <button
                                type="button"
                                className="rsm-mng__btn"
                                onClick={() => {
                                    from === 'list' ? navigate('/pafaa010') : navigate('/pajad010');
                                }}
                            >
                                목록
                            </button>
                        </div> */}
                        {data ? (
                            <div className="rsm_area" ref={printRef}>
                                {data?.title && <h2 className="rsm__tit">{data?.title}</h2>}
                                <div className="rsm__profile">
                                    <div className="rsm__img">
                                        <img
                                            src={
                                                data?.resumeLogo
                                                    ? getImageSrc('resume_logo', data?.resumeLogo)
                                                    : './images/default-avatar-white.png'
                                            }
                                            alt="avatar"
                                            className={!data?.resumeLogo ? 'rsm__img-empty' : ''}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = './images/default-avatar-white.png';
                                                e.target.classList.add('rsm__img-empty');
                                            }}
                                        />
                                    </div>
                                    <div className="rsm__info">
                                        <div className="rsm__name">
                                            <div className={'item-name'}>{data?.nameKor}</div>
                                            <span>{data?.resumeCareer === '001' ? '신입' : '경력'}</span>
                                        </div>
                                        <p>
                                            {data?.mobileNo ? data?.mobileNo : ''}
                                            {data?.telNo ? ` / ${data?.telNo}` : ''}
                                            {data?.email && (
                                                <>
                                                    <br />
                                                    {data?.email}
                                                </>
                                            )}
                                            {data?.homeUrl && (
                                                <>
                                                    <br />
                                                    {data?.homeUrl}
                                                </>
                                            )}
                                            <br />
                                            희망연락방법: {getContactMethod(data?.contactMethod)}
                                            <br />
                                            최종수정일 {formatDate(data?.modDate)}
                                        </p>
                                    </div>
                                    {decode?.authorities === 'ROLE_C' && (
                                        <div className="rsm__icon">
                                            <div className="rsm__icon-actions">
                                                <button
                                                    type="button"
                                                    className="rsm__icon-btn"
                                                    onClick={() => handlePrint(printRef, ['.rsm__icon'])}
                                                >
                                                    <img src="./images/icons/icon-print.png" alt="icon" />
                                                </button>
                                                {/* web */}
                                                <button
                                                    type="button"
                                                    className="rsm__icon-btn"
                                                    onClick={data?.isChoice === 'Y' ? removeStar : activeStar}
                                                >
                                                    {data?.isChoice === 'Y' ? (
                                                        <i className="icon icon-star icon-star-gray active"></i>
                                                    ) : (
                                                        <i className="icon icon-star-gray"></i>
                                                    )}
                                                </button>
                                                {data?.isUnlocked && (
                                                    <button
                                                        type="button"
                                                        className="rsm__icon-btn"
                                                        onClick={() => {
                                                            setIsPopupSendMailOpen(true);
                                                            setReceiver({
                                                                id: data?.memberID,
                                                                name: data?.nameKor,
                                                            });
                                                        }}
                                                    >
                                                        <img src="./images/icons/icon-letter-blk.png" alt="icon" />
                                                    </button>
                                                )}
                                            </div>
                                            {/* mobile */}
                                            <div className="rsm__icon-mobile">
                                                <button
                                                    type="button"
                                                    className="rsm__icon-btn"
                                                    onClick={data?.isChoice === 'Y' ? removeStar : activeStar}
                                                >
                                                    <span>
                                                        {data?.isChoice === 'Y' ? (
                                                            <i className="icon icon-star icon-star-gray active"></i>
                                                        ) : (
                                                            <i className="icon icon-star-gray"></i>
                                                        )}
                                                        초이스
                                                    </span>
                                                </button>
                                                {data?.isUnlocked && (
                                                    <button
                                                        type="button"
                                                        className="rsm__icon-btn"
                                                        onClick={() => {
                                                            setIsPopupSendMailOpen(true);
                                                            setReceiver({
                                                                id: data?.memberID,
                                                                name: data?.nameKor,
                                                            });
                                                        }}
                                                    >
                                                        <span>
                                                            <img
                                                                src="./images/icons/icon-letter-blk-white.png"
                                                                alt="icon"
                                                            />
                                                            쪽지
                                                        </span>
                                                    </button>
                                                )}
                                            </div>
                                            <div className="rsm__access-status">
                                                {!isDataLoaded ? null : data?.isUnlocked ? (
                                                    <>
                                                        <span style={{ color: '#076ecc' }}>
                                                            {data?.expireDate}까지 확인 가능
                                                        </span>
                                                        <button
                                                            type="button"
                                                            style={{
                                                                background: '#076ecc',
                                                                color: '#fff',
                                                                pointerEvents: 'none',
                                                            }}
                                                        >
                                                            열람권 사용 중
                                                        </button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span>
                                                            열람권 사용 시, 지원자 정보 확인 및 쪽지 발송이 가능합니다.
                                                        </span>
                                                        <button type="button" onClick={handleUseTicket}>
                                                            열람권 사용
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <ResumePage
                                    data={data}
                                    resumeSchoolInfo={resumeSchoolInfo}
                                    resumeCareerInfo={resumeCareerInfo}
                                    resumeLicenseInfo={resumeLicenseInfo}
                                    resumeActiveInfo={resumeActiveInfo}
                                />
                                <dl className="rsm__dl rsm__dl--gray">
                                    <dt style={{ fontSize: '13px' }}>위의 모든 내용은 사실과 다름없음을 확인합니다.</dt>
                                    <dd style={{ fontSize: '11px' }}>
                                        <span>
                                            덴탈잡에서는 남녀고용평등과 일·가정 양립 지원에 관한 법률에 의거 성별 및
                                            나이에 대한 정보를 표시하지 않습니다.
                                        </span>
                                        <span>
                                            본 정보는 사용자가 구직활동을 위해 등록한 이력서 정보이며, 덴탈잡은 기재된
                                            내용에 대한 오류와 사용자가 신뢰하여 취한 조치에 대해 책임을 지지 않습니다.
                                        </span>
                                        <span>
                                            본 정보는 어떠한 경우라도 덴탈잡이나 등록자의 동의없이 무단전재 및 재배포할
                                            수 없으며 채용 목적 이외의 용도로 사용할 수 없습니다.
                                        </span>
                                        <span>
                                            본 정보를 출력, 복사, 유출한 경우 개인정보보호에 대한 책임은 출력, 복사,
                                            유출 행위를 한 당사자에게 있으며 정보통신부 고시 제2005-18호에 따라 법에
                                            의해 책임을 지게 됨을 양지하시기 바랍니다.
                                        </span>
                                    </dd>
                                </dl>
                            </div>
                        ) : (
                            <div className="no-data">데이터 없습니다</div>
                        )}
                    </div>
                </div>
            </div>
            {isTicketPopupOpen && (
                <Ticket
                    onClose={() => setIsTicketPopupOpen(false)}
                    wallets={data?.wallets || []}
                    resumeSeq={id}
                    onCharge={() => {
                        setIsTicketPopupOpen(false);
                        setIsTicketPurchasePopupOpen(true);
                    }}
                />
            )}
            {isTicketPurchasePopupOpen && <TicketPurchase onClose={() => setIsTicketPurchasePopupOpen(false)} />}
            {isPopupSendMailOpen && <PopupSendMail closePopup={closePopup} receiver={receiver} />}
        </>
    );
};
export default PAFAA060;
